<script>
import {mapGetters} from "vuex";

export default {
  name: "ContentWrapper",
  props: {
    slicer: {
      default: 12,
    },
    contentCategory: {
      default: null,
      validator(value) {
        // The value must match one of these strings
        return typeof value == "object"
      }
    },
    categoryColumn: {
      default: 'slug',
      validator(value) {
        // The value must match one of these strings
        return ['id', 'slug'].includes(value)
      }
    },
    waitForCategory: {
      type: Boolean,
      default: false
    },
    contentType: {
      default: 'post',
      validator(value) {
        // The value must match one of these strings
        return ['post', 'page'].includes(value)
      }
    },
  },
  data() {
    return {
      current_page: 1,
      contents: [],
      categories: [],
      paginationMeta: [],
    }
  },
  computed: {
    ...mapGetters({
      filters: 'Content/getFilters'
    }),
    waitForCategoryStatus() {
      if (this.waitForCategory) {
        return this.contentCategory != null && this.contentCategory.length > 0
      }
      return true;
    }
  },
  methods: {
    async changePage(page) {

      await this.setContents(page)

      this.current_page = page


      this.$emit("current_page", page);
    },
    setCategoryColumn() {
      if (this.categoryColumn == null) {
        this.$store.commit("Content/setFilters", {key: "category_column", value: ''})
        return true
      }
      this.$store.commit("Content/setFilters", {key: "category_column", value: this.categoryColumn});
      return true
    },
    setCategories() {
      if (this.contentCategory == null) {
        this.$store.commit("Content/setFilters", {key: "category", value: []})
        return true
      }
      this.$store.commit("Content/setFilters", {key: "category", value: this.contentCategory});
      return true
    },
    setSlicer() {
      this.$store.commit("Content/setFilters", {key: "per_page", value: this.slicer})
      return true
    },
    async setContents(page = 1) {
      const form = {
        page: page,
        type: this.contentType
      }
      const response = await this.$store.dispatch('Content/getContentsWithoutState', {form})
      let data = response.data.data

      this.contents = data.data
      this.paginationMeta = data.meta

      this.$emit("contents", this.contents);
    },
    waitingHandler() {
      return this.waitForCategoryStatus
    },

    async initWrapper() {

      if (this.waitingHandler()) {
        this.setCategories()
        this.setCategoryColumn()
        this.setSlicer()

        // get contents
        await this.setContents()
      }

    }
  },
  render() {
    return this.$slots.default({
      contents: this.contents,
      pagination: this.paginationMeta,
      changePageFunction: this.changePage,
      current_page: this.current_page,
    });
  },
  async mounted() {
    await this.initWrapper();
  },
  watch: {
    contentCategory: {
      handler(newValue, oldValue) {
        this.initWrapper();
      },
      deep: true
    }
  }
}
</script>
